import { render, staticRenderFns } from "./publicDetails.vue?vue&type=template&id=15684ab1&scoped=true"
import script from "./publicDetails.vue?vue&type=script&lang=js"
export * from "./publicDetails.vue?vue&type=script&lang=js"
import style0 from "./publicDetails.vue?vue&type=style&index=0&id=15684ab1&prod&scoped=true&lang=less"
import style1 from "./publicDetails.vue?vue&type=style&index=1&id=15684ab1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15684ab1",
  null
  
)

export default component.exports